import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { loadThree } from '../utils/threeLoader';
import './ContactPage.css';

const DISCORD_URL = 'https://discord.gg/PpGtKhmbjx';
const CONTACT_EMAIL = 'purple@synestesia.world';

const ContactPage = () => {
  const canvasRef = useRef(null);
  const liquidAppRef = useRef(null);
  const [emailRevealed, setEmailRevealed] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    if (liquidAppRef.current && liquidAppRef.current.dispose) {
      liquidAppRef.current.dispose();
      liquidAppRef.current = null;
    }

    let isMounted = true;

    const loadLiquidBackground = async () => {
      try {
        await loadThree();
        const LiquidBackground = (await import('https://cdn.jsdelivr.net/npm/threejs-components@0.0.27/build/backgrounds/liquid1.min.js')).default;

        if (!isMounted) return;

        const app = LiquidBackground(canvas);

        if (!isMounted) {
          if (app && app.dispose) app.dispose();
          return;
        }

        liquidAppRef.current = app;
        app.loadImage('/obsidienne-soulages.jpg');
        app.liquidPlane.material.metalness = 0.75;
        app.liquidPlane.material.roughness = 0.25;
        app.liquidPlane.uniforms.displacementScale.value = 5;
        app.setRain(false);
      } catch (error) {
        console.error('Error loading LiquidBackground:', error);
      }
    };

    loadLiquidBackground();

    return () => {
      isMounted = false;
      if (liquidAppRef.current && liquidAppRef.current.dispose) {
        liquidAppRef.current.dispose();
        liquidAppRef.current = null;
      }
    };
  }, []);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(CONTACT_EMAIL);
  };

  return (
    <div className="contact-page">
      <canvas ref={canvasRef} id="canvas" className="contact-canvas"></canvas>
      <Navbar />
      <main className="contact-main">
        <div className="contact-container">
          <h1 className="contact-title">Contact</h1>
          <p className="contact-subtitle">Rejoignez notre communauté ou écrivez-nous</p>

          <div className="contact-buttons">
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-button contact-button-discord"
            >
              <svg className="contact-button-icon" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
              </svg>
              Rejoindre le serveur Discord
            </a>

            <div className="contact-email-section">
              <button
                type="button"
                className="contact-button contact-button-email"
                onClick={() => setEmailRevealed(!emailRevealed)}
              >
                <svg className="contact-button-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                {emailRevealed ? 'Masquer l\'email' : 'Afficher l\'email'}
              </button>
              {emailRevealed && (
                <div className="contact-email-revealed">
                  <span className="contact-email-value">{CONTACT_EMAIL}</span>
                  <button
                    type="button"
                    className="contact-copy-button"
                    onClick={handleCopyEmail}
                    title="Copier l'email"
                  >
                    Copier
                  </button>
                </div>
              )}
            </div>
          </div>

          <Link to="/" className="contact-back-link">
            ← Retour à l'accueil
          </Link>
        </div>
      </main>
    </div>
  );
};

export default ContactPage;
